import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: `'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
  },
  palette: {
    myVariant: {
      main: "#F2F2F2",
    },
    primary: {
      main: "#01008B",
      contrastText: "#fff",
    },
    secondary: {
      main: "#bb4a9b",
      contrastText: "#fff",
    },
    tertiary: {
      main: "green",
      contrastText: "#fff",
    },
    quaternary: {
      main: "#505050",
      contrastText: "#fff",
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            textTransform: "capitalize",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          scrollbarColor: "#bb4a9b #F2F2F2", // static color for Firefox
        },
        "*::-webkit-scrollbar": {
          width: "12px",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#bb4a9b",
          borderRadius: "6px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#9c3b83",
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: "#F2F2F2",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          fontWeight: "bold",
          color: "red",
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          description: "p",
          labelFilled: "p",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#4E4E4E",
          fontWeight: 500,
          fontFamily: "Montserrat",
        },
        shrink: {
          color: "#4E4E4E",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#01008BA8", // default border color
          borderWidth: "2px",
        },
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#01008BA8",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#01008BA8",
          },
        },
      },
    },
  },
});

export default theme;
